var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInst(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4232 8.24686C13.843 8.24686 10.8765 11.0617 10.8765 14.5678C10.8765 18.074 13.7918 20.8888 17.4232 20.8888C21.0546 20.8888 23.9699 18.0246 23.9699 14.5678C23.9699 11.1111 21.0035 8.24686 17.4232 8.24686ZM17.4232 18.6172C15.1216 18.6172 13.2292 16.7901 13.2292 14.5678C13.2292 12.3456 15.1216 10.5185 17.4232 10.5185C19.7248 10.5185 21.6172 12.3456 21.6172 14.5678C21.6172 16.7901 19.7248 18.6172 17.4232 18.6172Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2257 9.53087C25.0449 9.53087 25.7089 8.8897 25.7089 8.09877C25.7089 7.30784 25.0449 6.66667 24.2257 6.66667C23.4065 6.66667 22.7424 7.30784 22.7424 8.09877C22.7424 8.8897 23.4065 9.53087 24.2257 9.53087Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0618 4.39502C26.732 3.06169 24.8395 2.37033 22.6914 2.37033H12.1552C7.7055 2.37033 4.73901 5.23453 4.73901 9.53082V19.6543C4.73901 21.7777 5.45506 23.6049 6.88716 24.9382C8.26811 26.2222 10.1094 26.8642 12.2064 26.8642H22.6402C24.8395 26.8642 26.6808 26.1728 28.0106 24.9382C29.3916 23.6543 30.1076 21.8271 30.1076 19.7037V9.53082C30.1076 7.45675 29.3916 5.67897 28.0618 4.39502ZM27.8572 19.7037C27.8572 21.2345 27.2946 22.4691 26.3739 23.3086C25.4533 24.1481 24.1746 24.5926 22.6402 24.5926H12.2064C10.672 24.5926 9.39333 24.1481 8.4727 23.3086C7.55206 22.4197 7.09175 21.1851 7.09175 19.6543V9.53082C7.09175 8.04934 7.55206 6.81477 8.4727 5.92589C9.34219 5.08638 10.672 4.64194 12.2064 4.64194H22.7425C24.2769 4.64194 25.5556 5.08638 26.4762 5.97527C27.3457 6.86416 27.8572 8.09872 27.8572 9.53082V19.7037Z",
    fill: "#7D7D7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18_73",
    x: -1,
    y: 0,
    width: 37,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18_73"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18_73",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInst);
export default __webpack_public_path__ + "static/media/inst.ca0a9b6ea18ee8b50388a4bb18766dfa.svg";
export { ForwardRef as ReactComponent };